import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { Select } from '~/eds/src/components/Select/Select';
import { useClientId } from '~/hooks/useClientId';
import { api } from '~/redux/api/createApi';

interface Props {
  value: string[];
  onChange: (updatedValue: string[]) => void;
}

export const ClientContractTypeSelect = ({ value, onChange }: Props) => {
  const clientId = useClientId();
  const intl = useIntl();

  const { data: contractTypes = [], isFetching: isLoading } =
    api.endpoints.getClientContractTypes.useQuery({
      clientId,
    });

  const options = useMemo(
    () =>
      contractTypes.map((contractType) => ({
        label: contractType,
        value: contractType,
      })),
    [contractTypes],
  );

  return (
    <Select
      enableSelectAll={false}
      enableSorting={true}
      isMulti={true}
      isLoading={isLoading}
      name="document type select"
      placeholder={intl.formatMessage({
        id: 'ClientContractTypeSelect.placeholder',
        defaultMessage: 'Select document types',
        description: 'Placeholder text for document type selection',
      })}
      value={value}
      options={options}
      onChange={(updatedValue) => onChange(updatedValue ?? [])}
    />
  );
};
